import { QueryFactory } from '@lmt/shared-types';
import { ButtonColor } from '@lmt/unicorn-shared/app/components/common/ui-kit/buttons/Button';
import { UniLink } from '@lmt/unicorn-shared/app/components/common/ui-kit/buttons/UniLink';
import { pages } from '@lmt/unicorn-shared/app/constants/sharedRoutes';
import { useTabs } from '@lmt/unicorn-shared/app/features/navigation/operations';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React, { FC } from 'react';
import styles from './PatientRequestToast.module.scss';
import { getFullName } from '../patient-form/common/common';
import { ToastIcon } from '../../common/icons/toast/ToastIcon';

type Props = {
  patientId?: number; // if patient id is passed we assume that patient request was processed
};

export const PatientDataRequestToast: FC<Props> = (props) => {
  const tabs = useTabs();
  const i18next = useScopedTranslation('patients.notifications');
  const { patientId } = props;

  const patientQuery = QueryFactory.PatientQuery.useGetPatientQuery(
    patientId!,
    {
      enabled: !!patientId,
      throwOnError: false,
    },
  );
  const isRequestProcessed = !!patientId;
  const patient = patientQuery?.data;
  return (
    <div className={styles.container}>
      {isRequestProcessed ? (
        <ToastIcon type="success" />
      ) : (
        <ToastIcon type="warning" />
      )}
      <div className={styles.content}>
        {isRequestProcessed ? (
          <>
            <span className={styles.title}>
              {i18next.t('patient_imported_title', {
                name: patient ? getFullName(patient) : '',
              })}
            </span>
            <UniLink
              className={styles.message}
              color={ButtonColor.Primary}
              title={i18next.t('patient_link')}
              onClick={() =>
                tabs.openTab(
                  pages.patientProfile.link({ patientId: patientId! }),
                )
              }
            />
          </>
        ) : (
          <>
            <span className={styles.boldTitle}>
              {i18next.t('patient_request_in_progress_title')}
            </span>
            <span className={styles.message}>
              {i18next.t('patient_request_in_progress')}
            </span>
          </>
        )}
      </div>
    </div>
  );
};
